import React from 'react'
import { NavLink, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux'
import { logout, selectloginLogout } from '../../redux/Slice/login_logoutSclice';

const Navbar = () => {
const navigate = useNavigate()
    const dispatch = useDispatch();
    const cartData = useSelector(state => state.food.cart)
    const islogin = useSelector(selectloginLogout)

    return (
        <div>
            {/* <!-- Navbar --> */}
            <nav className="navbar navbar-expand-lg navbar-light " style={{ backgroundColor: 'primary', color: 'white', height: '60px' }} >
                {/* <!-- Container wrapper --> */}
                <div className="container-fluid">
                    {/* <!-- Toggle button --> */}
                    <button
                        className="navbar-toggler"
                        type="button"
                        data-mdb-toggle="collapse"
                        data-mdb-target="#navbarSupportedContent"
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation"
                    >
                        <i className="fas fa-bars"></i>
                    </button>

                    {/* <!-- Collapsible wrapper --> */}
                    <div className="collapse navbar-collapse" id="navbarSupportedContent">
                        {/* <!-- Navbar brand --> */}
                        <NavLink to='/' className="navbar-brand  mt-2 mt-lg-0">
                            <img
                                src="../images/logonav.jpg"
                                height="50"
                                width='150'
                                alt="MDB Logo"
                                loading="lazy"
                                style={{ objectFit: 'cover', backgroundColor: 'white', borderRadius: '.5rem' }}
                            />
                        </NavLink>
                        {/* <!-- Left links --> */}
                        {
                            !islogin && (
                                <ul style={{ color: 'white' }} className="navbar-nav me-auto mb-2 mb-lg-0">
                                    <li className="nav-item">
                                        <NavLink className="nav-link" to="/home">Home</NavLink>
                                    </li>

                                    <li className="nav-item">
                                        <a href='#aboutme' className="nav-link" >About Us</a>
                                    </li>
                                    <li className="nav-item">
                                        <a href='#contactme' className="nav-link" >contact</a>
                                    </li>
                                </ul>
                            )
                        }
                        {/* <!-- Left links --> */}
                    </div>
                    <div className="d-flex align-items-center">


                        {/* ===========Login & Logout =============== */}

                        {
                            islogin ? <>
                                <NavLink to='/login' style={{ marginRight: '1rem' }}>
                                   
                                </NavLink>
                                <NavLink to='/signup' style={{ marginRight: '1rem' }}>

                                    <button type="button" onClick={() => document.title = 'Signup now'} className="btn btn-primary">Signup</button>
                                </NavLink></> : ''
                        }





                        {
                            !islogin && (
                                <NavLink className="text-reset me-3" to="/sells">
                                    <button type="button" class="btn btn-primary position-relative">
                                        <i style={{ color: 'blue' }} className="fas fa-shopping-cart"></i>
                                        <span class="position-absolute top-0 start-100 translate-middle badge rounded-pill badge-danger">
                                            {cartData.length}
                                            <span class="visually-hidden">unread messages</span>
                                        </span>
                                    </button>

                                </NavLink>
                            )
                        }



                        {/* <!-- Avatar --> */}
                        {
                            islogin && (
                               
                                <button type = "button" class="btn btn-danger position-relative"style={{ border: 'none',  }}
                                    onClick={() => dispatch(logout())}
                                            >
                                    <NavLink style={{ backgroundColor:'#DC3545', color:'white'}}className="dropdown-item" to="/">
                                                    Logout
                                                </NavLink></button>

                            ) 
                        }
                    </div>
                </div> 
            </nav>
        </div>
    )
}

export default Navbar;